import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "matrix__wrapper" }
const _hoisted_2 = { class: "ws-textbox" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "matrix-table" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_6 = { class: "pax-fullname" }
const _hoisted_7 = ["name", "checked", "value", "disabled", "onChange"]
const _hoisted_8 = ["name"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StyledSFSMatrixSelect = _resolveComponent("StyledSFSMatrixSelect")!

  return (_openBlock(), _createBlock(_component_StyledSFSMatrixSelect, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("table", _hoisted_4, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_5,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.amount, (n) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: n,
                      class: "padding-td",
                      align: "center"
                    }, _toDisplayString(n), 1))
                  }), 128))
                ])
              ]),
              (_openBlock(), _createElementBlock("tbody", { key: _ctx.renderKey }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPaxs, (pax, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_6, _toDisplayString(pax?.first_name + ' ' + pax?.last_name), 1),
                    (!_ctx.isInfant(pax))
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.amount, (n) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: n,
                            align: "center",
                            class: "padding-td"
                          }, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: 'pax-' + pax?.passenger_id,
                              checked: _ctx.dataSelect[index] == n,
                              value: n,
                              disabled: _ctx.isAirlineSet,
                              onChange: ($event: any) => (_ctx.handleSelectMatrix(index, $event))
                            }, null, 40, _hoisted_7)
                          ]))
                        }), 128))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.amount, (n) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: n,
                            align: "center",
                            class: "padding-td"
                          }, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: 'pax-' + pax?.id,
                              disabled: ""
                            }, null, 8, _hoisted_8)
                          ]))
                        }), 128))
                  ]))
                }), 128))
              ]))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}